<script setup lang="ts">
import { computed } from 'vue'

import { BlockContainer } from '@toni/brand-ui'

import { usePageStore } from '../../../stores/page'
import { useContentBlock } from '../../../content-blocks/composables/use-content-block'
import VideoPlayer from './VideoPlayer.vue'
import { usePageBlockWidth } from '../../../composables/use-page-block-width.ts'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'video')

const pageStore = usePageStore()
const brand = pageStore.brandFromStore as string
const hasVideoSizeL = computed(() => contentBlock.value.data.video.layout?.size === 'l')
const isHome = computed(() => pageStore.isHome as boolean)
const pageBlockWidthSize = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand).value)
const size = computed(() => hasVideoSizeL.value ? 'full' : pageBlockWidthSize.value)

</script>

<template>
  <BlockContainer
    data-testid="embed-container"
    class="mt-3 md:mt-4 mb-6 md:mb-8"
    :size="size"
    :class="{ 'w-full lg:pl-[100px] xl:px-[100px]': hasVideoSizeL }">
    <VideoPlayer :video="contentBlock.data.video" />
  </BlockContainer>
</template>
